import {mapState} from 'vuex'
import selectUploadDoc from '@/views/renew/components/select-upload-doc'
import renewInsurerDialog from '@/views/renew/components/renew-insurer-dialog'
import {renewFileTypeName} from '@/utils/renew_type'
export default {
  components:{
    selectUploadDoc,
    renewInsurerDialog
  },
  props:{
    isReminder:{
      type: Boolean,
      default: false
    },
    fileList:{
      type: [Array,Object],
      default: ()=>[]
    },
    isRenewInsurer:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      showReminderDoc:false,
      showRenewInsurer:false,
      copyNcd:false
    }
  },
  computed:{
    file(){
      let file= this.fileList||[]
      return file||[]
    },
    file_list(){
      let {type} = this.otherData||{}
      let list = this.file.filter(item=>item.type == type)
      return list||[]
    },
    has_file(){
      return this.file_list.length>0||this.isRenewInsurer
    },
    renewFileTypeName(){
      let type_name = renewFileTypeName
      // if(this.isCompany)
      //   type_name.id_type_pic_path = 'Certificate of Incorporation/Business Registration Certificate'
      return type_name
    },
  },
  methods: {
    handleConpyNCD(data){
      this.copyNcd = data
      this.handleComputerUpload()
    },
    openSelectDoc(){
      if(this.disabled)return
      if(this.isRenewInsurer){
        this.showRenewInsurer = true
      }
      else if(this.has_file)
        this.showReminderDoc = true
    },
    handleComputerUpload(){
      this.$refs.upload.$el.querySelector('input').click()
    },
    handleSelectDocUpload(){
      this.$refs.upload.$el.querySelector('input').click()
    },
    handleReminderUpload(data){
      let {file_id,url,thumb_url,type,type_name,path} = data||{}
      let params = {
        data:{
          id:file_id,
          url,
          thumb_url,
          path,
          client_name:type_name||this.renewFileTypeName[type]
        },
        otherData:this.otherData
      }
      this.$emit('uploadSuccess',params)
      this.$emit('input',false)
    }
  }
}
